import { gql } from "graphql-tag";

const XPM_DEVICE_FIELDS = gql`
  fragment XpmDeviceFields on Devices {
    short_id
    status
    disposition
    subtype
    alias
    batteryLevel
    batteryStatus
    signalStrength
    renter {
      id
      firstName
      lastName
      primaryPhone
    }
  }
`;

export const FACILITY_DEVICES = gql`
  query FacilityDevices($facilityCode: String!) {
    facilityDevices(facilityCode: $facilityCode) {
      id
      ...XpmDeviceFields
    }
  }
  ${XPM_DEVICE_FIELDS}
`;

export const FACILITY_RENTERS = gql`
  query FacilityRenters($facilityCode: String!) {
    facilityRenters(facilityCode: $facilityCode) {
      id
      firstName
      lastName
      primaryPhone
    }
  }
`;

export const ADD_FACILITY_DEVICE_RENTER = gql`
  mutation AddFacilityDeviceRenter(
    $deviceId: ID!
    $renterId: ID!
    $facilityCode: String!
  ) {
    addFacilityDeviceRenter(
      deviceId: $deviceId
      renterId: $renterId
      facilityCode: $facilityCode
    ) {
      id
      ...XpmDeviceFields
    }
  }
  ${XPM_DEVICE_FIELDS}
`;

export const CREATE_FACILITY_RENTER = gql`
  mutation CreateFacilityRenter(
    $deviceId: ID!
    $facilityCode: String!
    $firstName: String!
    $lastName: String!
    $primaryPhone: String!
    $email: String
  ) {
    createFacilityRenter(
      deviceId: $deviceId
      facilityCode: $facilityCode
      firstName: $firstName
      lastName: $lastName
      primaryPhone: $primaryPhone
      email: $email
    ) {
      id
      ...XpmDeviceFields
    }
  }
  ${XPM_DEVICE_FIELDS}
`;

export const REMOVE_FACILITY_DEVICE_RENTER = gql`
  mutation RemoveFacilityDeviceRenter($deviceId: ID!, $facilityCode: String!) {
    removeFacilityDeviceRenter(
      deviceId: $deviceId
      facilityCode: $facilityCode
    ) {
      id
      ...XpmDeviceFields
    }
  }
  ${XPM_DEVICE_FIELDS}
`;
